import { ThemeUICSSObject } from '@apia/theme';
import list from './list';
import render from './render';
import primary from './primary';
/* IMPORT HERE */

const tabs: ThemeUICSSObject = {
  list,
  render,
  primary,
  /* PREPEND HERE */
};

export default tabs;
